// 商品管理
import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 主页面接口
// 获取配件列表
export function getGoodsList(data, params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/findAllParts',
    method: 'post',
    data,
    params
  })
}

// 查询所有品牌列表
export function getListAllBrand(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllBrand',
    method: 'get',
    params
  })
}
// 查询所有厂牌列表
export function getListAllLabel(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllLabel',
    method: 'get',
    params
  })
}
// 获取配件类型
export function getListPartsType(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listPartsType',
    method: 'get',
    params
  })
}
// 导出
export function getExport(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/export',
    method: 'post',
    data
  })
}
// 数据来源/货架状态/审核状态/最小单位
export function getDataFrom(data) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
    method: 'post',
    data
  })
}
// 通过配件id查询适用车型
export function getListCarModeByPartId(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listCarModeByPartId',
    method: 'get',
    params
  })
}
// 上架
export function putAway(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/putAway',
    // url: 'http://192.168.0.122:5000/wss-part/parts/putAway',
    method: 'post',
    data
  })
}
// 下架
export function undercarriage(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/undercarriage',
    // url: 'http://192.168.0.122:5000/wss-part/parts/undercarriage',
    method: 'post',
    data
  })
}

//  新增页面接口l

// 获取新增配件列表
export function getNewGoods(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/matching',
    // url: 'https://tsapi2.g-parts.cn/gpart-part-provider/parts/findPart',
    method: 'get',
    params
  })
}
// 保存新增配件
export function saveNewGoods(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/save',
    // url: 'https://tsapi2.g-parts.cn/gpart-part-provider/parts/findPart',
    method: 'post',
    data
  })
}

//  修改页面接口
// 获取初始图片
export function getImgs(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/findImagelByPartId',
    method: 'get',
    params
  })
}
// 批量上传图片
export function setImgs(data, params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/imageUpload',
    method: 'post',
    data,
    params
  })
}
// 删除配件
export function delPart(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/delete',
    method: 'delete',
    params
  })
}
// 配件申请接口
// 获取标准分组
export function treeList() {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllGroup',
    method: 'get'
  })
}
// 获取名称
export function findByPartTypeId(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllNameByPartTypeId',
    method: 'get',
    params
  })
}
// 获取厂牌
export function findAllBrand() {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllLabel',
    method: 'get'
  })
}
// 获取品牌
export function findAllNoPage() {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllBrand',
    method: 'get'
  })
}
// 获取车系
export function findByParams(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listCarSeriesByBrandId',
    method: 'get',
    params
  })
}
// 获取车型
export function findCarByParams(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listCarModelByCarSeriesId',
    method: 'get',
    params
  })
}
// 申请配件
export function applyNewGoods(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/apply',
    // url: 'https://tsapi2.g-parts.cn/gpart-part-provider/parts/findPart',
    method: 'post',
    data
  })
}
// 上传图片回填

// // 配件替换关系
// export function getGoodsreplace(params) {
//   return axios.request({
//     url:
//       'https://tsapi2.g-parts.cn/gpart-part-provider/partsReplace/findAllOeByPartId?partId=12920748&approved=1',
//     method: 'get',
//     params
//   })
// }

// // 关联链
// export function getGoodsrelevance(params) {
//   return axios.request({
//     url:
//       'https://tsapi2.g-parts.cn/gpart-part-provider/partsReplace/findAllOeByPartId?partId=12920748&approved=1',
//     method: 'get',
//     params
//   })
// }
